<template>
<div class="chapter">
<div class="inner_page">
<p class="hd1"><b>DEDICATION</b></p>
<p class="noindent">This book is dedicated with the deepest respect and love to my grandmother, Sadie Ruby. Sadie loved embroidery and passed her passion on to me. I am also dedicating this to my wonderful Scott, for his unlimited enthusiasm and support for my adventures in art and embroidery.</p>
<p class="fig"><img alt="" src="images/pg7_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?dda938fa